import React from 'react';
import { Header } from './components/layout/Header';
import { SiteFooter } from './components/layout/SiteFooter';
import { Home } from './pages/Home';
export function App() {
  return <div className="flex min-h-screen w-full flex-col bg-ivory" data-id="element-0" data-mp="3k9b5e485fs2s">
      <Header data-id="element-1" data-mp="3k7i474gb2026" />
      <div className="flex-1" data-id="element-2" data-mp="3fahywvra51c4">
        <Home data-id="element-3" data-mp="3fa89b9a5cw6y" />
      </div>
      <SiteFooter data-id="element-4" data-mp="3fb17hlv1iddh" />
    </div>;
}